<template>
  <div class="register">
    <!-- 背景装饰 -->
    <div class="login-bg-decoration">
      <div class="football-icon football-icon-1"></div>
      <div class="football-icon football-icon-2"></div>
      <div class="football-icon football-icon-3"></div>
      <div class="goal-icon goal-icon-1"></div>
      <div class="goal-icon goal-icon-2"></div>
    </div>

    <div class="container">
      <!-- 头部 -->
      <div class="common-header">
        <div class="close" @click="$router.go(-1)"></div>
        <div class="login-btn" @click="$parent.goNav('/login')">登录</div>
      </div>

      <!-- LOGO -->
      <div class="login-brand">
        <div class="brand-logo">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="28" stroke="#165DFF" stroke-width="2" fill="#F8FAFC"/>
            <path d="M30 10V50" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M10 30H50" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 17L43 43" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M17 43L43 17" stroke="#165DFF" stroke-width="1.5" stroke-linecap="round"/>
            <circle cx="30" cy="30" r="8" fill="#165DFF" opacity="0.8"/>
          </svg>
        </div>
        <div class="brand-text">
          <h1 class="brand-name">{{ $store.state.appInfo.title }}</h1>
          <p class="brand-desc">万种游戏玩法 · 应有尽有</p>
        </div>
      </div>

      <!-- 跑马灯 -->
      <div class="marquee-box">
        <i></i>
        <div class="marquee">
          <div class="tempWrap" style="overflow:hidden;position:relative;width:100%">
            <div class="marquee-box-inner" style="width:3531px;position:relative;left:-585px">
              <span class="marquee-box-item clone">恭喜 ****75d存款 800.00CNY 领取240.00CNY</span>
              <span class="marquee-box-item">恭喜 ****75d存款 510.00CNY 领取178.50CNY</span>
              <span class="marquee-box-item">恭喜 ****92a存款 30,000.00CNY 领取12,000.00CNY</span>
              <span class="marquee-box-item">恭喜 ****92a存款 30,000.00CNY 领取10,500.00CNY</span>
              <span class="marquee-box-item clone">恭喜 ****75d存款 800.00CNY 领取240.00CNY</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 注册标题 -->
      <div class="register-title"><h2 class="page-title">会员注册</h2></div>
      <!-- 注册表单 -->
      <div class="phone-register">
        <div class="register-form card-shadow">
          <!-- 邀请码输入框 - 只有当URL中有pid参数时显示 -->
          <div class="login-group" v-if="showInviteCode">
            <label class="input-label">邀请码</label>
            <div class="login-input">
              <input 
                v-model="registerInfo.pid"
                type="text" 
                placeholder="邀请码"
                class="inpt input-style"
                readonly
              />
            </div>
          </div>
          
          <div class="login-group" v-for="(field, i) in formFields" :key="i">
            <label class="input-label">{{ field.label }}</label>
            <div v-if="field.model !== 'code'" class="login-input">
              <input 
                v-model="registerInfo[field.model]"
                :type="field.inputType" 
                :maxlength="field.maxlength"
                :placeholder="field.placeholder"
                class="inpt input-style"
              />
            </div>
            <div v-else class="login-input captcha-wrap">
              <input 
                v-model="registerInfo.code"
                type="text"
                maxlength="4"
                placeholder="请输入验证码"
                class="input-style captcha-inpt"
              />
              <canvas 
                ref="captchaCanvas" 
                data-ref-key="registerCaptcha"
                width="100" 
                height="36" 
                class="captcha-code" 
                @click="generateCaptcha" 
                title="点击刷新验证码"
              ></canvas>
            </div>
          </div>
        </div>
        <!-- 注册按钮 -->
        <div class="register-btn btn-gradient" @click="register">
          <span class="btn-text">创建账户</span>
          <i class="btn-icon"></i>
        </div>
      </div>
    </div>

    <p class="notes">
      <i class="icon-shield"></i>{{ $store.state.appInfo.title }}采用256位AES安全加密，国际认证安全措施，绝不会向任何第三方泄露您的敏感信息
    </p>
  </div>
</template>

<script>
export default {
  name:'register',
  data(){ 
    return {
      registerInfo:{}, 
      captchaValue:'',
      formFields:[
        {label:'用户名',model:'name',inputType:'text',maxlength:19,placeholder:'用户名长度不得低于6位，字母和数字组合',readonly:true},
        {label:'登录密码',model:'password',inputType:'password',maxlength:16,placeholder:'密码长度最少8位，字母和数字组合'},
        {label:'确认密码',model:'confirmPass',inputType:'password',maxlength:16,placeholder:'请再次输入登录密码'},
        {label:'真实姓名',model:'realname',inputType:'text',maxlength:32,placeholder:'请输入真实姓名，中英文均可'},
        {label:'支付密码',model:'paypassword',inputType:'password',maxlength:6,placeholder:'请输入6位支付密码'},
        {label:'验证码',model:'code',inputType:'text',maxlength:4,placeholder:'请输入验证码'}
      ]
    }
  },
  computed: {
    // 根据URL参数判断是否显示邀请码输入框
    showInviteCode() {
      // 直接从路由中获取最新的pid参数
      return this.$route.query.pid !== undefined && this.$route.query.pid !== '';
    }
  },
  watch: {
    // 深度监听路由变化，确保任何情况下都能捕获参数变化
    '$route'(to, from) {
      // 无论从哪个页面跳转过来，都重新检查pid参数
      if (to.query.pid) {
        this.registerInfo.pid = to.query.pid;
      } else {
        delete this.registerInfo.pid;
      }
    }
  },
  created() {
    // 在组件创建时就获取pid参数，确保初始加载时就能获取到
    if (this.$route.query.pid) {
      this.registerInfo.pid = this.$route.query.pid;
    }
  },
  mounted(){ 
    // 确保DOM完全渲染后再生成验证码
    this.$nextTick(() => {
      this.generateCaptcha();
    });
    
    // 跑马灯初始化
    if(window.jQuery&&jQuery.fn.slide){ 
      jQuery('.marquee').slide({ mainCell:'.marquee-box-inner', autoPlay:true, effect:'leftMarquee', vis:2, interTime:50 }); 
    } 
  },
  methods:{
    generateCaptcha(){
      // 修复：用 && 替换可选链，兼容低版本ES
      let canvas = this.$refs.captchaCanvas;
      if (Array.isArray(canvas)) {
        // 传统逻辑判断：先判断el存在，再判断tagName
        canvas = canvas.find(function(el) {
          return el && el.tagName === 'CANVAS';
        });
      }
      // 验证canvas有效性
      if (!canvas || canvas.tagName !== 'CANVAS') {
        console.warn('未找到有效的canvas元素');
        return;
      }
      const ctx = canvas.getContext('2d');
      if(!ctx) {
        console.warn('浏览器不支持canvas 2D上下文');
        return;
      }
      ctx.clearRect(0,0,canvas.width,canvas.height);
      // 背景渐变
      const bgGradient = ctx.createLinearGradient(0,0,canvas.width,0);
      bgGradient.addColorStop(0,'#f8fafc');
      bgGradient.addColorStop(1,'#f1f5f9');
      ctx.fillStyle = bgGradient;
      ctx.fillRect(0,0,canvas.width,canvas.height);
      // 生成4位验证码
      const chars='ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      let captcha='';
      for(let i=0;i<4;i++){
        captcha+=chars.charAt(Math.floor(Math.random()*chars.length));
      }
      this.captchaValue=captcha;
      // 绘制验证码
      ctx.font='bold 18px "Arial","Microsoft YaHei",sans-serif';
      ctx.textAlign='center';
      ctx.textBaseline='middle';
      for(let i=0;i<captcha.length;i++){
        const x=20+i*20;
        const y=canvas.height/2 + (Math.random()*10 - 5);
        const rotate=(Math.random()*40 - 20)*Math.PI/180;
        ctx.save();
        ctx.translate(x,y);
        ctx.rotate(rotate);
        ctx.fillStyle='#165DFF';
        ctx.fillText(captcha[i],0,0);
        ctx.restore();
      }
    },
    register(){
      const info=this.registerInfo;
      const code=info.code||'';
      const namereg=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/;
      const passwordreg=/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;
      const realnamereg=/^[\u0391-\uFFE5a-zA-Z·&\s]+$/;
      const paypasswordreg=/^.{6}$/;

      if(!namereg.test(info.name)) return this.$parent.showTost(0,'用户名长度不得低于6位，以字母和数字组合！');
      if(!passwordreg.test(info.password)) return this.$parent.showTost(0,'密码长度最少8位！以字母和数字组合！');
      if(info.confirmPass!==info.password) return this.$parent.showTost(0,'两次密码不一致！');
      if(!realnamereg.test(info.realname)) return this.$parent.showTost(0,'姓名格式不正确，可以是中，英文名称！');
      if(!paypasswordreg.test(info.paypassword)) return this.$parent.showTost(0,'支付密码长度需是6位！');
      if(code.toUpperCase()!==this.captchaValue.toUpperCase()){ 
        this.generateCaptcha(); 
        this.registerInfo.code=''; 
        return this.$parent.showTost(0,'验证码错误！'); 
      }

      // 如果有邀请码，确保它被包含在提交的数据中
      if (this.showInviteCode && !info.pid) {
        return this.$parent.showTost(0,'邀请码不能为空！');
      }

      this.$parent.showLoading();
      this.$apiFun.register(info).then(res=>{
        this.$parent.hideLoading();
        this.$parent.showTost(1,res.message);
        if(res.code===200){ 
          sessionStorage.setItem('token',res.data.api_token); 
          this.$store.commit('changToken'); 
          this.$parent.getUserInfo(); 
        }
        this.generateCaptcha();
      }).catch(()=>{ 
        this.$parent.hideLoading(); 
        this.$parent.showTost(0,'网络异常，请稍后重试'); 
      });
    }
  }
}
</script>

<style scoped lang="scss">
.register{width:100%;min-height:100vh;padding:20px;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;position:relative;overflow:hidden;background:#fff;}
.container{width:100%;max-width:420px;display:flex;flex-direction:column;align-items:center;gap:16px;position:relative;z-index:1;}
.login-bg-decoration{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:0;opacity:.04;}
.football-icon,.goal-icon{position:absolute;background-size:contain;background-repeat:no-repeat;background-position:center;}
.football-icon{width:80px;height:80px;}
.football-icon-1{top:10%;left:5%;} .football-icon-2{top:60%;right:8%;transform:rotate(30deg);} .football-icon-3{bottom:15%;left:20%;transform:rotate(-15deg);}
.goal-icon{width:120px;height:60px;}
.goal-icon-1{top:30%;right:15%;transform:rotate(10deg);} .goal-icon-2{bottom:30%;left:10%;transform:rotate(-5deg);}
.login-brand{display:flex;flex-direction:column;align-items:center;z-index:1;}
.brand-logo{margin-bottom:12px;transition:transform .3s;} .brand-logo:hover{transform:scale(1.05);}
.brand-name{font-size:22px;color:#165DFF;font-weight:600;text-align:center;margin-bottom:4px;}
.brand-desc{font-size:13px;color:#9ca3af;text-align:center;letter-spacing:.5px;}
.marquee-box {
  width: 100%;
  padding: 4px 8px;       /* 从8px 12px改为4px 8px */
  background: #f8fafc;
  border-radius: 4px;     /* 从8px改为4px */
  display: flex;
  align-items: center;
  margin-bottom: 4px;     /* 从8px改为4px */
  font-size: 12px;        /* 可以适当减小字体，让整体更紧凑 */
}
.common-header{width:100%;display:flex;justify-content:space-between;align-items:center;z-index:1;}
.login-btn {
  padding: 6px 16px;
  border-radius: 20px;
  border: 1px solid #165DFF;
  color: #165DFF;
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  background: #fff;
  
  &:hover {
    background: #f0f7ff;
  }
}
.register-title{text-align:center;margin-bottom:2px;}.page-title{font-size:20px;font-weight:600;color:#1f2937;}
.register-form{background:#fff;padding:24px;border-radius:12px;border:1px solid #f3f4f6;box-shadow:0 8px 24px rgba(0,0,0,.06);}
.login-group{margin-bottom:5px;}
.input-label{display:flex;align-items:center;font-size:14px;color:#4b5563;margin-bottom:3px;font-weight:500;}
.login-input{display:flex;align-items:center;}
.input-style {
  width: 100%;
  height: 44px;
  padding: 0 10px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  outline: none;
  font-size: 14px;
  color: #1f2937;
  transition: all 0.3s;
}
.input-style:focus{border-color:#165DFF;box-shadow:0 0 0 3px rgba(22,93,255,.1);background:#fff;}
.btn-gradient{width:100%;height:48px;background:linear-gradient(90deg,#165DFF 0,#36BFFA 100%);color:#fff;border-radius:8px;font-size:16px;font-weight:500;text-align:center;line-height:48px;cursor:pointer;display:flex;justify-content:center;align-items:center;gap:8px;box-shadow:0 4px 16px rgba(22,93,255,.2);}
.notes{text-align:center;font-size:12px;color:#9ca3af;margin-top:20px;display:flex;align-items:center;justify-content:center;padding:0 16px;box-sizing:border-box;}
  .close {
	margin-left: 2px;
    width: 28px;
    height: 28px;
    cursor: pointer;
    background-size: 85%; 
    background-repeat: no-repeat;
    background-position: center;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="%23165DFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18L9 12L15 6"/></svg>');
    transition: background-size 0.2s ease;
  }
.captcha-code {
  width: 100px;
  height: 36px;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  display: inline-block;
  vertical-align: middle;
  background-color: #fff;
}
.captcha-inpt {
  flex: 1;
  height: 36px;
  padding: 0 10px;
}
.captcha-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
    


// WEBPACK FOOTER //
// src/components/main/register.vue